import api from '../../api/_commande'


const state = () => ({
    commandes: [],
    commande: [],

})

// getters
const getters = {
    commandes: (state) => {
        return state.commandes
    },
    commande: (state) => {
        return state.commande
    },

}

// actions
const actions = {
    /**
     * Liste des fournisseurs
     */
    getCommandes({commit}) {
        api.bonCommandes().then(
            response => {
                commit('SET_COMMANDES', response)
            }
        )
    },

    saveBonCommande({commit, dispatch}, data) {
        api.saveBonCommande(data).then(
            response=> {

                commit('SET_COMMANDE', response)
                dispatch('getCommandes')
            }
        )
    },

    getBonCommande({commit}, id) {
        api.getBonCommande(id).then(
            response=> {
                commit('SET_COMMANDE', response)
            }
        )
    },

    deleteBonCommande({dispatch},id) {
        api.deleteBonCommande(id).then(
            response=> {
                dispatch('getCommandes')
                console.log(response)
            }
        )
    },

    deleteArticleBonCommande({dispatch},{id, data}) {

        api.deleteArticleBonCommande(id, data).then(
            response=> {
                dispatch('getBonCommande', id)
                console.log(response)
            }
        )
    },
    




}

// mutations
const mutations = {
    
    SET_COMMANDES(state,commandes) {
        state.commandes = commandes
    },

    SET_COMMANDE(state,commande) {
        state.commande = commande
    },

}

export default {
  state,
  getters,
  actions,
  mutations
}
